import type { GridSizingHandler } from './GridSizingHandler.js';
import type { WallpaperHandler } from './WallpaperHandler.js';

/**
 * A specialized {@linkcode MessageEvent} for handling messages from ad creative iframes.
 */
export type CreativeMessageEvent = MessageEvent<CreativeMessageEvent.Data>;

export namespace CreativeMessageEvent {
  export enum Type {
    SetGridSizing = 'setGridSizing',
    SetWallpaper = 'setWallpaper'
  }

  export type Data = GridSizingHandler.Data | WallpaperHandler.Data;

  export namespace Data {
    export type Value<TType extends Type, TData extends object> = {
      readonly type: TType;
    } & Readonly<TData>;
  }

  export function isGoogleSafeFrameOrigin(origin: string): boolean {
    try {
      const url = new URL(origin);
      return url.hostname.endsWith('.safeframe.googlesyndication.com');
    } catch {
      return false;
    }
  }
}
